import axiosInstance from './axiosInstance';

export const getMyWallets = () => axiosInstance.get('/wallet/me');
export const getMyTransactions = (type) => axiosInstance.get('/wallet/transactions', { params: { type } });
